<template>
	<div class="login layout" id="login">
		<login v-if="$route.name=='login'" :setPsw="setPsw" @setstatus="setstatus"></login>
		<setPassword :setPsw="setPsw"></setPassword>
		<div class="login-copyright"> © 2018 zhiyun-tech.com All rights reserved. 桂林智神信息技术有限公司 桂ICP备15010724号-1</div>
	</div>
</template>

<script>
	import login from '@/components/loginPage/login'
	import setPassword from '@/components/loginPage/setPassword'
	export default {
		name: 'loginPage',
		data() {
			return {
				setPsw: 1,
			}
		},
		components: {
			login,
			setPassword
		},
		 beforeCreate: function() {
		 	document.getElementsByTagName("html")[0].className="html";
	        document.getElementsByTagName("body")[0].className="body";
	    },
		created: function() {
			let user = this.getLocalUser
			if(user) {
				location.href = "/"
			}
		},
		mounted: function() {},
		methods: {
			setstatus: function(data) {
				this.setPsw = 0
			}
		},
		 beforeDestroy: function() {
		 	document.html.removeAttribute("class","html");
	        document.body.removeAttribute("class","body");
	    }

	}
</script>

<style scoped="scoped">
	@import url("../../static/css/login.css");
	.login {
		height: 100%;
		padding-top: 250px;
	}
	.layout{
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/assets/loginPage.vue